import { useEffect, useRef } from 'react'
import { logBrazePageView } from '../../Utils/analytics/brazeAnalytics'
import { useContext } from 'react'
import { AuthContext } from '../../Api/firebase/authContext'
import { useLazyLocation } from '../location'

/**
 * Hook to track page views for Braze
 * It waits for both Braze to be initialized and auth to finish loading before tracking
 * @param brazeInitialized Whether Braze is initialized
 */
export const useBrazePageTracking = (brazeInitialized?: boolean) => {
  const auth = useContext(AuthContext)!
  const { authLoading, isAnonymous } = auth
  const lastTrackedPath = useRef<string>('')
  const shouldLoadLocation = !!brazeInitialized && !authLoading
  const location = useLazyLocation(shouldLoadLocation)

  useEffect(() => {
    if (!brazeInitialized || authLoading) return
    if (!shouldLoadLocation || !location) return

    const { pathname, search, pageName } = location
    if (pathname === lastTrackedPath.current) return

    const brazePageName = pageName ? `_${pageName}` : ''
    logBrazePageView(brazePageName, {
      url: pathname,
      query_params: search,
      timestamp: new Date().toISOString(),
      is_anonymous: isAnonymous,
    })

    lastTrackedPath.current = pathname
  }, [brazeInitialized, authLoading, location?.pathname, location?.search])

  return { location }
}
